import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { useToggle } from '@infl-ts/util-hooks';
import { Button, css, MenuItem, MenuList, Select, styled, SwipeableDrawer, Typography, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as Eq from 'fp-ts/Eq';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ButtonStyles = function ButtonStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n  height: 40px;\n\n  &:hover,\n  &:active {\n    background: ", ";\n  }\n\n  > div:focus {\n    background: ", ";\n  }\n"])), theme.palette.text.primary, theme.palette.secondary.main, theme.palette.secondary.dark, theme.palette.secondary.dark);
};

var SortSelect = styled(Select)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  .MuiSelect-select {\n    display: flex;\n  }\n\n  > fieldset {\n    border: none;\n  }\n"])), ButtonStyles);
var MobileSortButton = styled(Button)(function (p) {
  return ButtonStyles(p);
});

var ButtonText = function ButtonText(_ref2) {
  var value = _ref2.value;
  return /*#__PURE__*/_jsx(Typography, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'bold'
    },
    variant: "body2",
    "data-element": "Typography",
    "data-component": "ButtonText",
    "data-source-file": "index.tsx",
    children: value
  });
};

export var SortButton = function SortButton(_ref3) {
  var entity = _ref3.entity,
      sortBy = _ref3.sortBy,
      handleChangeSort = _ref3.handleChangeSort,
      sortOptions = _ref3.sortOptions;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      open = _useToggle2$.on,
      close = _useToggle2$.off;

  var uniqueSortOptions = A.uniq(Eq.fromEquals(function (x, y) {
    return x === y;
  }))(sortOptions);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MobileSortButton, {
      onClick: isOpen ? close : open,
      children: /*#__PURE__*/_jsx(ButtonText, {
        value: t(sortBy)
      })
    }), /*#__PURE__*/_jsxs(SwipeableDrawer, {
      open: isOpen,
      onClose: close,
      onOpen: open,
      anchor: "bottom",
      disablePortal: true,
      disableSwipeToOpen: true,
      children: [/*#__PURE__*/_jsx(Typography, {
        sx: {
          fontWeight: 'bold',
          pt: 2,
          px: 1.5
        },
        variant: "h4",
        children: t('Sort {{entity}}', {
          entity: t(entity)
        })
      }), /*#__PURE__*/_jsx(MenuList, {
        children: uniqueSortOptions.map(function (option) {
          return /*#__PURE__*/_jsx(MenuItem, {
            selected: option === sortBy,
            sx: {
              p: 1.5
            },
            onClick: function onClick() {
              handleChangeSort(option);
              close();
            },
            children: t(option)
          }, option);
        })
      })]
    })]
  }) : /*#__PURE__*/_jsx(SortSelect, {
    size: "small",
    onChange: function onChange(evt) {
      return handleChangeSort(evt.target.value);
    },
    renderValue: function renderValue() {
      return /*#__PURE__*/_jsx(ButtonText, {
        value: t(sortBy)
      });
    },
    MenuProps: {
      disablePortal: true
    },
    value: sortBy,
    children: uniqueSortOptions.map(function (option) {
      return /*#__PURE__*/_jsx(MenuItem, {
        value: option,
        selected: option === sortBy,
        children: t(option)
      }, option);
    })
  });
};